import { Component } from "react";
import Link from "admin/shared/ui/Link.Component";
import moment from "moment";

export default class BookingItem extends Component {
  render() {
    return (
      <div>
        <strong>
          [{this.props.item.Id}]{" "}
          {moment(this.props.item.RequestTimestamp).format("YYYY-MM-DD")}:{" "}
        </strong>

        <Link
          toState={"userOverview"}
          parameters={["identity", this.props.item.AccountId]}
        >
          {this.props.item.FullName}
        </Link>
        <span> {this.props.item.Amount.Amount} kr</span>
      </div>
    );
  }
}
